const LAST_WORKSPACE_STORAGE_KEY = 'lastWorkspaceId'

export function getLastWorkspaceId(): string | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const value = window.localStorage.getItem(LAST_WORKSPACE_STORAGE_KEY)
    return value && value.length > 0 ? value : null
  } catch {
    return null
  }
}

export function setLastWorkspaceId(workspaceId: string): void {
  if (typeof window === 'undefined' || workspaceId.length === 0) {
    return
  }

  try {
    window.localStorage.setItem(LAST_WORKSPACE_STORAGE_KEY, workspaceId)
  } catch {
    // Ignore storage errors and continue without persistence.
  }
}

export function clearLastWorkspaceId(): void {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.removeItem(LAST_WORKSPACE_STORAGE_KEY)
  } catch {
    // Ignore storage errors and continue without persistence.
  }
}
